import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-etoll-empty-state',
  standalone: true,
  imports: [ButtonModule, TranslateModule],
  templateUrl: './etoll-empty-state.component.html',
  styleUrls: ['./etoll-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EtollEmptyStateComponent {}
